import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { SearchQueryPredicate } from "types/generated";

import { SEARCH_SPACELIFT_VCS_FILES_SUGGESTIONS } from "./gql";

type UseSearchSpaceliftVcsFilesSuggestionsProps = {
  repoId: string | undefined;
  predicates?: SearchQueryPredicate[] | null;
  skip?: boolean;
};

const useSearchSpaceliftVcsFilesSuggestions = ({
  repoId,
  predicates,
  skip,
}: UseSearchSpaceliftVcsFilesSuggestionsProps) => {
  const { data, loading, error, previousData, refetch } = useQuery(
    SEARCH_SPACELIFT_VCS_FILES_SUGGESTIONS,
    {
      variables: {
        repoID: repoId || "",
        commit: null,
        input: {
          fullTextSearch: null,
          predicates: predicates ?? null,
          fields: null,
        },
      },
      skip: skip || !repoId,
    }
  );

  const filteredCount = useMemo(
    () =>
      data?.searchRepoFilesSuggestions.filteredCount ??
      previousData?.searchRepoFilesSuggestions.filteredCount ??
      0,
    [data, previousData]
  );

  return {
    filteredCount,
    loading,
    error,
    refetch,
  };
};

export default useSearchSpaceliftVcsFilesSuggestions;
